import {  BATCH_LIST, BATCH_DETAILS } from './../constant/ActionTypes';

export const batchReducer = (state, action) => {
    switch (action.type) {
        case BATCH_LIST:
            return { 
                ...state, 
                batchList: action.payload 
            };
        case BATCH_DETAILS:
            return { 
                ...state, 
                batchDetails: action.payload 
            };
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./contexts/reducer/batchReducer.js